import 'babel-polyfill';

import 'regenerator-runtime/runtime'
import "element-ui/lib/theme-chalk/index.css";
import "assets/css/reset.css";
import "assets/css/element-new-ui.scss";
import "ol/ol.css";
import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "router/routerMap";
import echarts from "echarts";
import ElementUI from "element-ui";
import md5 from "js-md5";

import {Engine, EmptySky} from 'mapv-three';
import {BoxGeometry, MeshStandardMaterial, Mesh} from 'three';
import wow from 'wowjs'
import ElementTreeLine from 'element-tree-line'
import 'element-tree-line/dist/style.css'
import '@/assets/css/public.scss'
/* import BaiduMap from 'vue-baidu-map' */
import TinyLayer from 'tinylayer'
import moment from "moment";
Vue.use(ElementUI);
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

Vue.prototype.$wow = wow
Vue.prototype.$md5 = md5; //加密字符串

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
